export const plans = [
	{
		title: 'Hot Discount Days',
		desc: 'Each Friday we deliver highest discounts',
		author: 'Chef Deming',
		date: '30 min ago',
		location: 'Turkey, Istambul',
		img: '/img/discount.webp',
	},
	{
		title: 'Coming Soon',
		desc: 'Be ready for fresh Arrivals from Monday!',
		author: 'Belissimo Arthur',
		date: '2 days ago',
		location: 'Turkey, Istambul',
		img: '/img/fresh.webp',
	},
	{
		title: 'New Project Lunch',
		desc: 'New Restaurant is opening in Florida',
		author: 'Morgan News',
		date: '5 days ago',
		location: 'USA, Florida',
		img: '/img/coming.webp',
	},
	{
		title: 'Join us on sns',
		desc: '🥬 We are offering healthy food reciepies on sns',
		author: 'Belissimo Agent',
		date: 'A week ago',
		location: 'Europe, France',
		img: '/img/food-city.webp',
	},
];
